import type { CatalogUpdateControl } from "./types";

export type ControlSnapshot = {
  data: CatalogUpdateControl | null;
  state: "loading" | "ready" | "error";
  updatedAt: string | null;
};

export const INITIAL_CONTROL: ControlSnapshot = { data: null, state: "loading", updatedAt: null };

export function controlReceived(data: CatalogUpdateControl, updatedAt: string): ControlSnapshot {
  return { data, state: "ready", updatedAt };
}

export function controlFailed(previous: ControlSnapshot): ControlSnapshot {
  return { ...previous, state: "error" };
}

export function controlChecking(previous: ControlSnapshot): ControlSnapshot {
  return { ...previous, state: "loading" };
}

export function controlPresentation(snapshot: ControlSnapshot) {
  const known = snapshot.data !== null;
  const run = snapshot.data?.run;
  return {
    known,
    actionsBlocked: snapshot.state !== "ready" || !known,
    title: run?.phase_label ?? (known ? "Actualización completa preparada"
      : snapshot.state === "error" ? "Estado del ciclo no disponible" : "Consultando estado"),
    message: run?.message ?? (known ? "Inicia un ciclo nuevo desde la descarga de iDirecto. El progreso comenzará en 0 %."
      : "No se puede confirmar si existe un ciclo activo hasta recibir respuesta del servidor."),
    label: snapshot.state === "error" ? (known ? "Último estado conocido" : "Estado desconocido")
      : !known ? "Consultando estado" : run?.status_label ?? "Sin ciclo activo",
    percent: known ? run?.progress_percent ?? 0 : undefined,
  };
}
